module.exports = __webpack_public_path__ + "static/fblike-80259cc59fa90750798331103b707f1a.png";